export const VIEW_ALL_AUDITIONEES = 'VIEW_ALL_AUDITIONEES';
export const EMAIL_SMS_PAYMENT_LINK_REMINDERS = 'EMAIL_SMS_PAYMENT_LINK_REMINDERS';
export const VIEW_ALL_USERS = 'VIEW_ALL_USERS';
export const UPDATE_USER_ROLES = 'UPDATE_USER_ROLES';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const AUDITIONEE_APPROVE_REJECT = 'AUDITIONEE_APPROVE_REJECT';
export const AUDITIONEE_SCHEDULE_RESCHEDULE = 'AUDITIONEE_SCHEDULE_RESCHEDULE';
export const VIEW_NEWS = 'VIEW_NEWS';
export const DAYPLAN_UPLOAD = 'DAYPLAN_UPLOAD';
export const NEWS_UPLOAD = 'NEWS_UPLOAD';
export const EXPENSE_UPLOAD = 'EXPENSE_UPLOAD';
export const DAYPLAN_APPROVE_REJECT = 'DAYPLAN_APPROVE_REJECT';
export const NEWS_APPROVE_REJECT = 'NEWS_APPROVE_REJECT';
export const EXPENSE_APPROVE_REJECT = 'EXPENSE_APPROVE_REJECT';
/* global BigInt */
export const role_privilege_map = [
  {
    id: 0,
    role: "Auditionee",
    bin: "00000000000000",
  },
  {
    id: 1,
    role: "Vendor",
    bin: "10000000000000",
  },
  {
    id: 2,
    role: "Grameen Reporter",
    bin: "00000001111000",
  },
  {
    id: 3,
    role: "Block Approver",
    bin: "00000001111110",
  },
  {
    id: 4,
    role: "District Approver",
    bin: "00000001111111",
  },
  {
    id: 5,
    role: "State Approver",
    bin: "00000001111111",
  },
  {
    id: 6,
    role: "HO Approver",
    bin: "00000001011111",
  },
  {
    id: 7,
    role: "Administrator",
    bin: "11111010000000",
  },
  {
    id: 8,
    role: "Audition Judge",
    bin: "10000100000000",
  },
];

export function privileges(roleIds) {

  const privilegeArray = roleIds.map((roleId) => {
    const role = role_privilege_map.find((item) => item.id === roleId);
    return role ? role.bin : null;
  });

  var ORBinary = (a, b) => {
    return (BigInt(`0b${a}`) | BigInt(`0b${b}`)).toString(2);
  };
  let s = "0";
  for (let i = 0; i < privilegeArray.length; i++) {
    s = ORBinary(s, privilegeArray[i]);
  }
  var hexPrivilege = parseInt(s, 2).toString(16).toUpperCase();
  return hexPrivilege;
}

export function hexToBinary(hexPrivilege) {
  return parseInt(hexPrivilege, 16).toString(2).padStart(8, "0");
}

export function allowedFeatures(binary) {
  var str = binary.toString();
  var indices = [];
  for (var i = 0; i < str.length; i++) {
    if (str[i] == "1") {
      indices.push(i);
    }
  }
  return indices;
};

const features = {
  0: VIEW_ALL_AUDITIONEES,
  1: EMAIL_SMS_PAYMENT_LINK_REMINDERS,
  2: VIEW_ALL_USERS,
  3: UPDATE_USER_ROLES,
  4: UPDATE_USER_DATA,
  5: AUDITIONEE_APPROVE_REJECT,
  6: AUDITIONEE_SCHEDULE_RESCHEDULE,
  7: VIEW_NEWS,
  8: DAYPLAN_UPLOAD,
  9: NEWS_UPLOAD,
  10: EXPENSE_UPLOAD,
  11: DAYPLAN_APPROVE_REJECT,
  12: NEWS_APPROVE_REJECT,
  13: EXPENSE_APPROVE_REJECT
};

export function featureByIndex(index) {
  return features[index];
}

/**
 * e.g.
 * Audition Screen --> check privileges from redux
 * 
 * hexToBinary --> 00100101010000
 * allowedFeatures --> [2,5,7,9]
 * 
 * featureByIndex[2] --> VIEW_ALL_USERS
 * featureByIndex[5] --> AUDITIONEE_APPROVE_REJECT
 * featureByIndex[7] --> VIEW_NEWS
 * featureByIndex[9] --> NEWS_UPLOAD
 * 
 * if (featureByIndex[2] === VIEW_ALL_USERS) --> true --> decide show/hide
*/
